import axios from 'axios';
//import { window.API_BASE_URL } from '../config.js';
import Cookies from 'universal-cookie'


const initialState = {
    conversationList: [],
    selectedConversation: [],
    conversationCharts: {},
    allConversationsList: [],
    sendingMessage: false,
};
// Action Types
const GET_CONVERSATION_MESSAGES = 'GET_CONVERSATION_MESSAGES';
const GET_CONVERSATION_BY_FLOW_ID = 'GET_CONVERSATION_BY_FLOW_ID';
const GET_CONVERSATION_CHART = 'GET_CONVERSATION_CHART';
const GET_ALL_CONVERSATIONS = 'GET_ALL_CONVERSATIONS';
const SEND_MESSAGE_TO_CONVERSATION = 'SEND_MESSAGE_TO_CONVERSATION';
const MARK_CONVERSATION_READ = 'MARK_CONVERSATION_READ';

// Reducer
export default function conversationReducer(state = initialState, action) {
    switch (action.type) {
        case GET_CONVERSATION_BY_FLOW_ID:
            return {
                ...state,
                conversationList: action.payload
            };
        case GET_CONVERSATION_MESSAGES:
            return {
                ...state,
                selectedConversation: action.payload
            };
        case GET_CONVERSATION_CHART:
            return {
                ...state,
                conversationCharts: action.payload
            };
        case GET_ALL_CONVERSATIONS:
            return { ...state, allConversationsList: action.payload };
        case MARK_CONVERSATION_READ:
            return {
                ...state,
                allConversationsList: state.allConversationsList.map(c =>
                    c.id === action.payload ? { ...c, unreadCount: 0 } : c
                ),
            };
        case SEND_MESSAGE_TO_CONVERSATION:
            return { ...state, sendingMessage: action.payload };
        default:
            return state;
    }
}


// Action Creators
export const GetConversationsByFlowId = (conversations) => ({
    type: GET_CONVERSATION_BY_FLOW_ID,
    payload: conversations,
});

export const GetConversationMessages = (messages) => ({
    type: GET_CONVERSATION_MESSAGES,
    payload: messages,
});

export const GetConversationChart = (messages) => ({
    type: GET_CONVERSATION_CHART,
    payload: messages,
});

export const SetAllConversations = (conversations) => ({
    type: GET_ALL_CONVERSATIONS,
    payload: conversations,
});

export const markConversationRead = (conversationId) => ({
    type: MARK_CONVERSATION_READ,
    payload: conversationId,
});

// API Integration Functions
export const fetchConversationsByFlowIdFromAPI = (flowId) => async (dispatch) => {
    try {
        const cookies = new Cookies()
        const response = await axios.get(`${window.API_BASE_URL}/Conversations/GetConversationByFlow/${flowId}`, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        });

        // El backend a veces puede devolver:
        // - un array directo
        // - un objeto paginado { items: [], data: [], results: [] }
        // Normalizamos para no “perder” conversaciones.
        const raw = response.data;
        const list = Array.isArray(raw)
            ? raw
            : (raw?.items || raw?.data || raw?.results || raw?.conversations || []);

        const normalized = Array.isArray(list) ? list : [];

        // Normalizar nombres de campos para UI (nuevo contrato backend)
        const mapped = normalized.map((c) => {
            const Stage = c?.Stage ?? c?.stage ?? null;
            const StageSummary = c?.StageSummary ?? c?.stageSummary ?? c?.stage_summary ?? null;

            return {
                ...c,
                Stage,
                StageSummary,
            };
        });

        mapped.sort((a, b) => {
            const dateA = new Date(a?.startedAt || 0).getTime();
            const dateB = new Date(b?.startedAt || 0).getTime();
            return dateB - dateA;
        });

        dispatch(GetConversationsByFlowId(mapped));
    } catch (error) {
        console.error('Error fetching conversations by flow ID:', error);
    }
};

export const fetchAllConversationsFromAPI = (businessLineId = null) => async (dispatch) => {
    try {
        const cookies = new Cookies();
        const params = { page: 1, pageSize: 50 };
        if (businessLineId !== null) params.businessLineId = businessLineId;
        const response = await axios.get(`${window.API_BASE_URL}/Conversations/GetAllConversations`, {
            params,
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        });

        const raw = response.data;
        const list = Array.isArray(raw)
            ? raw
            : (raw?.items || raw?.data || raw?.results || raw?.conversations || []);

        const normalized = Array.isArray(list) ? list : [];

        const mapped = normalized.map((c) => {
            const Stage = c?.Stage ?? c?.stage ?? null;
            const StageSummary = c?.StageSummary ?? c?.stageSummary ?? c?.stage_summary ?? null;
            return { ...c, Stage, StageSummary };
        });

        mapped.sort((a, b) => {
            const dateA = new Date(a?.startedAt || 0).getTime();
            const dateB = new Date(b?.startedAt || 0).getTime();
            return dateB - dateA;
        });

        dispatch(SetAllConversations(mapped));
    } catch (error) {
        console.error('Error fetching all conversations:', error);
    }
};

// TODO: Backend endpoint POST /Conversations/SendMessage pendiente.
// Frontend completamente conectado, se activará cuando el backend esté listo.
export const sendMessageToConversation = (conversationId, messageText) => async (dispatch) => {
    dispatch({ type: SEND_MESSAGE_TO_CONVERSATION, payload: true });
    try {
        const cookies = new Cookies();
        await axios.post(
            `${window.API_BASE_URL}/Conversations/SendMessage`,
            { conversationId, message: messageText },
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        dispatch({ type: SEND_MESSAGE_TO_CONVERSATION, payload: false });
    } catch (error) {
        console.error('Error sending message:', error);
        dispatch({ type: SEND_MESSAGE_TO_CONVERSATION, payload: false });
    }
};

export const pollConversationMessages = (conversationId) => async (dispatch) => {
    try {
        const cookies = new Cookies();
        const RES = await axios.get(
            `${window.API_BASE_URL}/Conversations/ConversationMessaging/${conversationId}`,
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        if (RES.status === 200) {
            dispatch({
                type: 'GET_CONVERSATION_MESSAGES_ONLY',
                payload: { success: true, message: '', list: RES.data }
            });
        }
    } catch {
        // falla silenciosa: no interrumpir la UI
    }
};

export const updateConversationNoteInAPI = (conversationId, summary) => async () => {
    try {
        const cookies = new Cookies();
        await axios.patch(
            `${window.API_BASE_URL}/Conversations/${conversationId}/summary`,
            { summary },
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
    } catch (error) {
        console.error('Error saving note:', error);
    }
};

export const closeConversationInAPI = (conversationId) => async () => {
    try {
        const cookies = new Cookies();
        await axios.patch(
            `${window.API_BASE_URL}/Conversations/${conversationId}/close`,
            {},
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
    } catch (error) {
        console.error('Error closing conversation:', error);
        throw error;
    }
};

export const takeoverConversationInAPI = (conversationId, enable) => async () => {
    try {
        const cookies = new Cookies();
        const res = await axios.patch(
            `${window.API_BASE_URL}/Conversations/${conversationId}/takeover`,
            { enable },
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        return res.data;
    } catch (error) {
        console.error('Error toggling takeover:', error);
        throw error;
    }
};

export const sendTemplateToConversationInAPI = (conversationId, templateId) => async () => {
    try {
        const cookies = new Cookies();
        const res = await axios.post(
            `${window.API_BASE_URL}/Conversations/${conversationId}/send-template`,
            { templateId },
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        return res.data;
    } catch (error) {
        console.error('Error sending template:', error);
        throw error;
    }
};

export const reactivateConversationInAPI = (conversationId) => async () => {
    try {
        const cookies = new Cookies();
        const res = await axios.patch(
            `${window.API_BASE_URL}/Conversations/${conversationId}/reactivate`,
            {},
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        return res.data;
    } catch (error) {
        console.error('Error reactivating conversation:', error);
        throw error;
    }
};

export const startConversationInAPI = (clientId, accountId, message, templateId) => async () => {
    try {
        const cookies = new Cookies();
        const res = await axios.post(
            `${window.API_BASE_URL}/Conversations/start`,
            { clientId, accountId, message, templateId },
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        return res.data;
    } catch (error) {
        console.error('Error starting conversation:', error);
        throw error;
    }
};

// API Integration Functions
export const fetchConversationChartsFromAPI = () => async (dispatch) => {
    try {
        const cookies = new Cookies();
        const response = await axios.post(`${window.API_BASE_URL}/Conversations/Charts`, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        });
        const data = await response.data;
        dispatch(GetConversationChart(data));
    } catch (error) {
        console.error('Error fetching conversation messages:', error);
    }
};
